import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined'

interface NextStepsProps {
  isPreapproved?: boolean,
  source: string
}

const NextSteps: React.FC<NextStepsProps> = ({ isPreapproved = false, source }) => {
  return (
    <Container
      sx={{
        width: '100%',
        textAlign: 'center',
        padding: '0 16px',
        boxSizing: 'border-box',
        mt: 9
      }}
      maxWidth="md"
      component="section"
    >
      <Box
        sx={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          margin: '0 auto 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(79, 70, 229, 0.08)'
        }}
      >
        <PhoneInTalkOutlinedIcon sx={{ fontSize: '28px', color: '#4F46E5' }} />
      </Box>

      <Typography
        component="h2"
        variant="headlineMedium"
      >
        What happens next?
      </Typography>

      <Typography
        variant="bodyLarge"
        sx={{
          maxWidth: '620px',
          margin: '0 auto 12px'
        }}
        component="p"
      >
        {isPreapproved
          ? 'Your Zuto Car Buying Expert will give you a quick call to confirm a few details and guide you through the next steps.'
          : source === 'carmoola' ?
            'We have a large panel of lenders which we are checking your application against. If we have an offer for you, your Zuto Car Buying Expert will give you a quick call to confirm a few details and guide your next steps.'
            : 'If we have an offer for you, your Zuto Car Buying Expert will give you a quick call to confirm a few details and guide your next steps.'}
      </Typography>

      <Typography
        variant="bodyLarge"
        sx={{
          maxWidth: '620px',
          margin: '0 auto'
        }}
      >
        {isPreapproved
          ? "Want to get ahead? Create your My Zuto account to track your application, browse cars, and upload the documents we'll need."
          : "You'll be able to see your online decision in your My Zuto account. Create your account to check, and you can browse cars and upload the documents we'll need."}
      </Typography>
    </Container>
  )
}

export default NextSteps
